import { render, staticRenderFns } from "./signInWithToken.vue?vue&type=template&id=496764ed"
import script from "./signInWithToken.vue?vue&type=script&lang=js"
export * from "./signInWithToken.vue?vue&type=script&lang=js"
import style0 from "./signInWithToken.vue?vue&type=style&index=0&id=496764ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports